<ng-template #formEdit>
  <div class="modal-header" style="padding: 5px 15px;" (click)="common.outSide($event)">
      <h4 class="modal-title pull-left"> Signature du bon {{ bon.numBon }} </h4>
      <button type="button" class="close pull-right" aria-label="Close" (click)="common.closeModal();closeFunction()">
          <span aria-hidden="true">&times;</span>
      </button>
  </div>
  <div class="modal-body " style="height: auto;padding: 15px 0;font-family: Roboto-Regular;
  font-size: 14px;" (click)="common.outSide($event)">
      <div class="col-sm-12" style="padding: 0px;">
          <div class="col-sm-12">
            <canvas id="myCanvas" style="border:1px solid #d3d3d3; width: 100%; height: 300px!important">
              Your browser does not support the HTML5 canvas tag.</canvas>  
          </div>          
      </div>
      <div class="text-right col-sm-12" style="margin-top: 15px;">
        <button class="btn-closeMdl btn-validerMdl" autofocus
              (click)="captureSignature()"
              [disabled]="isClicked">
              Capturer Signature
          </button>
          <button class="btn-closeMdl btn-validerMdl" autofocus
              (click)="saveSignature()"
              [disabled]="isClicked">
              Valider
          </button>
          <button type="button" class="btn-closeMdl"
              (click)="common.closeModal();closeFunction()">
              Annuler </button>
      </div>
  </div>
</ng-template>

<ng-template #msg>
  <div class="modal-body" style="height: auto">
      <div>
          <div class="col-sm-12">
              <label class="cofirmemsg"> {{ error }} </label>
          </div>
      </div>
      <div class="text-right" style="margin-top: 15px;">
          <button type="button" class="btn-closeMdl" (click)="closeModalError()"> Fermer
          </button>
      </div>
  </div>
</ng-template>
